import { jsx as a, jsxs as A } from "react/jsx-runtime";
import { Slot as E } from "@radix-ui/react-slot";
import { Loader2 as I } from "lucide-react";
import { forwardRef as L } from "react";
import { c as e } from "./cn-DlLpp5ix.js";
import { F as _ } from "./focus-BJKdC9pu.js";
const C = {
  // primary — bg-accent-default, text-on-accent. Default.
  primary: e(
    "bg-accent text-on-accent border border-transparent",
    "hover:bg-accent-hover",
    "active:bg-accent-hover",
    "data-[disabled=true]:bg-bg-elevated data-[disabled=true]:text-tertiary"
  ),
  // secondary — bg-elevated + secondary text + default border.
  secondary: e(
    "bg-bg-elevated text-secondary border border-default",
    "hover:bg-bg-hover hover:text-primary",
    "active:bg-bg-active",
    "data-[disabled=true]:bg-bg-elevated data-[disabled=true]:text-tertiary"
  ),
  // ghost — transparent + subtle border + secondary text. Replaces .ls-ghost.
  ghost: e(
    "bg-transparent text-secondary border border-subtle",
    "hover:bg-bg-hover hover:text-primary",
    "active:bg-bg-active",
    "data-[disabled=true]:text-tertiary data-[disabled=true]:bg-transparent"
  ),
  // tertiary — transparent, no border, secondary text. Dense rows.
  tertiary: e(
    "bg-transparent text-secondary border border-transparent",
    "hover:bg-bg-hover hover:text-primary",
    "active:bg-bg-active",
    "data-[disabled=true]:text-tertiary data-[disabled=true]:bg-transparent"
  ),
  // danger — error-tinted ghost (Reconnect red).
  danger: e(
    "bg-transparent text-error border border-error-border",
    "hover:bg-error-bg",
    "active:bg-error-bg",
    "data-[disabled=true]:text-tertiary data-[disabled=true]:border-subtle data-[disabled=true]:bg-transparent"
  ),
  // success — success-tinted ghost (Push to Leads, Resume).
  success: e(
    "bg-transparent text-success border border-success-border",
    "hover:bg-success-bg",
    "active:bg-success-bg",
    "data-[disabled=true]:text-tertiary data-[disabled=true]:border-subtle data-[disabled=true]:bg-transparent"
  )
}, B = {
  // sm: 28 / pad 4 10 / 11px
  sm: "h-7 px-2.5 py-1 text-2xs gap-1.5",
  // md: 32 / pad 8 12 / 12px (default)
  md: "h-8 px-3 py-2 text-xs gap-2",
  // lg: 40 / pad 12 16 / 13px
  lg: "h-10 px-4 py-3 text-sm gap-2"
}, R = {
  sm: "w-7 h-7 p-0",
  md: "w-8 h-8 p-0",
  lg: "w-10 h-10 p-0"
}, O = {
  sm: "w-3 h-3",
  md: "w-3.5 h-3.5",
  lg: "w-4 h-4"
}, j = e(
  // layout
  "inline-flex items-center justify-center select-none",
  // shape
  "rounded-lg border-solid",
  // typography
  "font-semibold leading-none",
  // motion
  "transition-colors duration-fast ease-out",
  // focus — ring-focus class lives in tokens.css
  _,
  // disabled cursor
  "data-[disabled=true]:cursor-not-allowed data-[loading=true]:cursor-progress",
  // pointer-events: none on disabled to block clicks even when class is bypassed
  "data-[disabled=true]:pointer-events-none"
), Z = L(function(h, n) {
  const {
    variant: o = "primary",
    size: r = "md",
    fullWidth: v = !1,
    iconOnly: s = !1,
    iconLeft: l,
    iconRight: b,
    loading: t = !1,
    asChild: x = !1,
    disabled: y = !1,
    className: f,
    children: d,
    type: S,
    "aria-busy": N,
    "aria-disabled": w,
    ...c
  } = h, i = y || t, u = t ? /* @__PURE__ */ a(I, { className: e(O[r], "animate-ls-spin"), "aria-hidden": "true" }) : l, g = e(
    j,
    C[o],
    s ? R[r] : B[r],
    v && "w-full",
    f
  ), p = {
    "data-disabled": i || void 0,
    "data-loading": t || void 0,
    "data-variant": o,
    "data-size": r
  }, m = {
    "aria-busy": N ?? (t || void 0),
    "aria-disabled": w ?? (i || void 0)
  };
  return x ? /* @__PURE__ */ a(E, { ref: n, className: g, ...p, ...m, ...c, children: d }) : /* @__PURE__ */ A(
    "button",
    {
      ref: n,
      type: S ?? "button",
      className: g,
      disabled: i,
      ...p,
      ...m,
      ...c,
      children: [
        u ? /* @__PURE__ */ a("span", { className: "inline-flex items-center", "aria-hidden": t ? "true" : void 0, children: u }) : null,
        !s && d !== void 0 ? /* @__PURE__ */ a("span", { children: d }) : null,
        s && !t ? /* @__PURE__ */ a("span", { className: "inline-flex items-center", "aria-hidden": "true", children: l ?? d }) : null,
        b && !s ? /* @__PURE__ */ a("span", { className: "inline-flex items-center", "aria-hidden": "true", children: b }) : null
      ]
    }
  );
});
Z.displayName = "Button";
export {
  Z as B
};
//# sourceMappingURL=Button-icgr8OM9.js.map
